<div class="review-container">
  <!-- Two Dropdowns side by side -->
  <div class="dropdown-row">
    <!-- Left Dropdown -->
    <div class="dropdown-box">
      <select id="artifactType" [(ngModel)]="selectedArtifactType" (change)="onArtifactChange()">
        <option value="" disabled selected>Select type</option>
        <option *ngFor="let type of artifactTypes" [value]="type">{{ type }}</option>
      </select>
    </div>

    <!-- Right Dropdown -->
    <div class="dropdown-box custom-dropdown">
      <ng-container *ngIf="artifactNames?.length > 0; else noArtifacts">
        <select id="artifactItem" [(ngModel)]="selectedItem" class="artifact-dropdown">
          <option *ngFor="let item of artifactNames" [ngValue]="item">
            {{ item.name }}
          </option>
        </select>
      </ng-container>

      <ng-template #noArtifacts>
        <select class="artifact-dropdown" disabled>
          <option disabled selected>No artifact present</option>
        </select>
      </ng-template>
    </div>
  </div>

  <!-- Textarea for comment -->
  <div class="input-group">
    <textarea [(ngModel)]="reviewComment" placeholder="Enter your review comment here..."></textarea>
  </div>

  <!-- Submit button -->
  <div class="submit-btn">
    <button (click)="submitReview()">Submit</button>
  </div>

  <!-- History box -->
  <div class="history-box">
    <label>History of reviews given on Report</label>

    <div class="history-list" *ngIf="reviewHistory.length > 0; else noHistory">
      <ul>
        <li *ngFor="let review of reviewHistory">
          <strong>{{ review.comment }}</strong><br />
          <small>By: {{ review.user }} on {{ review.time }}, Artifact Name : {{review.artifact_name}}
            ({{review.artifact_type}})</small>
        </li>
      </ul>
    </div>

    <ng-template #noHistory>
      <p class="no-review-p">No reviews yet.</p>
    </ng-template>
  </div>

</div>